import { render, staticRenderFns } from "./U8quantityonhandreporttable.vue?vue&type=template&id=bdd4765c&scoped=true&"
import script from "./U8quantityonhandreporttable.vue?vue&type=script&lang=js&"
export * from "./U8quantityonhandreporttable.vue?vue&type=script&lang=js&"
import style0 from "./U8quantityonhandreporttable.vue?vue&type=style&index=0&id=bdd4765c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd4765c",
  null
  
)

export default component.exports